import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  useTheme,
} from "@mui/material";
import PendingActionsIcon from "@mui/icons-material/PendingActions";

const formatter = (v) =>
  v.toLocaleString("es-AR", { 
    minimumFractionDigits: 2,
    maximumFractionDigits: 2 
  });

const TablaPendientes = ({ pendientes }) => {
  const theme = useTheme();

  if (!pendientes || pendientes.length === 0) {
    return null;
  }

  // Calcular total de pendientes
  const totalPendientes = pendientes.reduce((sum, p) => sum + (p.importe_total || 0), 0);

  return (
    <Paper
      elevation={0}
      sx={{
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 2,
        overflow: "hidden",
        mt: 3,
      }}
    >
      <Box sx={{ p: 2, borderBottom: `1px solid ${theme.palette.divider}` }}>
        <Typography
          variant="h6"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            fontWeight: 600,
            color: "text.primary",
          }}
        >
          <PendingActionsIcon fontSize="small" color="warning" />
          Pendientes de Facturación
        </Typography>
      </Box>

      <Table size="small">
        <TableHead>
          <TableRow sx={{ backgroundColor: "grey.50" }}>
            <TableCell sx={{ fontWeight: 600, py: 2 }}>ID Pedido</TableCell>
            <TableCell sx={{ fontWeight: 600, py: 2 }}>Razón Social</TableCell>
            <TableCell sx={{ fontWeight: 600, py: 2 }}>CUIT</TableCell>
            <TableCell sx={{ fontWeight: 600, py: 2 }}>Dirección</TableCell>
            <TableCell sx={{ fontWeight: 600, py: 2 }}>Producto</TableCell>
            <TableCell sx={{ fontWeight: 600, py: 2 }}>Fecha</TableCell>
            {/* <TableCell align="right" sx={{ fontWeight: 600, py: 2 }}>
              Importe
            </TableCell> */}
          </TableRow>
        </TableHead>

        <TableBody>
          {pendientes.map((p, i) => (
            <TableRow
              key={i}
              sx={{
                "&:last-child td": { borderBottom: 0 },
                "&:hover": { backgroundColor: "action.hover" },
              }}
            >
              <TableCell sx={{ py: 2 }}>
                <Typography variant="body2">#{p.id}</Typography>
              </TableCell>
              <TableCell sx={{ py: 2 }}>
                <Typography variant="body2">{p.razon_social || "-"}</Typography>
              </TableCell>
              <TableCell sx={{ py: 2 }}>
                <Typography variant="body2">{p.cuit || "-"}</Typography>
              </TableCell>
              <TableCell sx={{ py: 2 }}>
                <Typography variant="body2" sx={{ maxWidth: 250 }}>
                  {p.direccion_entrega || "-"}
                </Typography>
              </TableCell>
              <TableCell sx={{ py: 2 }}>
                <Typography variant="body2" sx={{ maxWidth: 300 }}>
                  {p.producto_renglon || "-"}
                </Typography>
              </TableCell>
              <TableCell sx={{ py: 2 }}>
                <Typography variant="body2">
                  {p.fecha_para ? new Date(p.fecha_para).toLocaleDateString() : "-"}
                </Typography>
              </TableCell>
              {/* <TableCell align="right" sx={{ py: 2 }}>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  ${formatter(p.importe_total || 0)}
                </Typography>
              </TableCell> */}
            </TableRow>
          ))}

          {/* Fila de total */}
          {/* <TableRow sx={{ backgroundColor: "grey.50" }}>
            <TableCell colSpan={6} align="right">
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Total Pendientes
              </Typography>
            </TableCell>
            <TableCell align="right">
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                ${formatter(totalPendientes)}
              </Typography>
            </TableCell>
          </TableRow> */}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default TablaPendientes;